import React, { memo } from "react";
import styles from "./index.module.less";
import { Button } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

const renderDescription = description => {
  if (description && typeof description !== "string") {
    return description;
  }

  const text = String(description || "");
  const marker = "全额退款";
  const index = text.indexOf(marker);

  if (index === -1) {
    return text;
  }

  return (
    <>
      {text.slice(0, index)}
      <strong className={styles.refundEmphasis}>{marker}</strong>
      {text.slice(index + marker.length)}
    </>
  );
};

const ComplaintConfirmModal = ({
  onConfirm,
  onCancel,
  visible = false,
  title = "确认全部退款？",
  description = "此操作将对当前客诉单关联的所有未退款订单进行全额退款，且操作不可撤销。",
  confirmText = "确认退款",
  loading = false
}) => {
  if (!visible) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalOverlayContent}>
        <div className={styles.modalOverlayContentImg}>
          <ExclamationCircleFilled className={styles.modalOverlayContentIcon} />
        </div>
        <div className={styles.modalTitle}>{title}</div>
        <div className={styles.warningText}>{renderDescription(description)}</div>
        <div className={styles.modalfooter}>
          <Button
            size="large"
            className={styles.modalfooterBtnCancel}
            onClick={onCancel}
            disabled={loading}
          >
            取消
          </Button>
          <Button
            type="primary"
            className={styles.modalfooterBtnConfirm}
            danger
            size="large"
            loading={loading}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(ComplaintConfirmModal);
